module.exports = __webpack_public_path__ + "img/bt_google_play.901fd1d4.png";